import "./darkmode.css";
import { useEffect, useState } from "react";

const DarkMode = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    let storedTheme = localStorage.getItem("site-dark-mode");
    const currentMode = JSON.parse(storedTheme);
    const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)")
      .matches
      ? "dark"
      : "light";
    console.log(systemPrefersDark);
    if (currentMode || systemPrefersDark) {
      setDarkMode(true);
    } else {
      setDarkMode(false);
    }
  }, []);

  useEffect(
    () => {
      if (darkMode) {
        document.documentElement.setAttribute("data-theme", "dark");
      } else {
        document.documentElement.setAttribute("data-theme", "light");
      }
      const storedTheme = JSON.stringify(darkMode);
      localStorage.setItem("site-dark-mode", storedTheme);
    },
    [darkMode]
  );

  console.log(darkMode);
  return (
    <div className="theme-switch-wrapper">
      <label className="theme-switch">
        <button
          className="toggle-theme ui icon button"
          value={darkMode}
          onClick={() => {
            setDarkMode(!darkMode);
            localStorage.setItem("site-dark-mode", JSON.stringify(darkMode));
          }}
        >
          {darkMode ? <i className="sun icon" /> : <i className="moon icon" />}
        </button>
      </label>
    </div>
  );
};

export default DarkMode;
